import { useEffect, useState } from "react";
import ZeroWasteList from "../../components/ZeroWaste/ZeroWasteList";
import styles from "./ZeroWasteFee.module.scss";
import clsx from "clsx";
import donationApi from "../../apis/donationApi";
import { useSnackbar } from "notistack";
import ZeroWasteFeeConfigModal from "../../components/ZeroWaste/ZeroWasteFeeConfigModal";
import { typeZeroWaste } from "../../constants/constant";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

export interface ZeroWasteFeeProps {
  className?: string;
}
const initPayload = {
  filter: {
    ids: [
    ],
    packageTypeId: "",
    partnerId: "",
  },
  paging: {
    limit: 0,
    offset: 0,
  },
};
const ZeroWasteFee = (props: ZeroWasteFeeProps) => {
  const { className } = props;
  const [payload, setPayload] = useState(initPayload);
  const [zeroWasteList, setZeroWasteList] = useState<any[]>([]);
  const {enqueueSnackbar} = useSnackbar();
  const [reload, setReload] = useState(false)

  useEffect(() => {
    (async () => {
      const res = await donationApi.searchZeroWaste(payload);
      if(res.data.code === 0){
        const sorted = res.data.data.data.sort((a: any, b: any) => { const getNum = (name: string) => { const m = String(name).match(/\d+/); return m ? parseInt(m[0], 10) : 0; }; const nameA = typeZeroWaste(a.partnerPackageTypesConfigId) || a.packageTypeName || ""; const nameB = typeZeroWaste(b.partnerPackageTypesConfigId) || b.packageTypeName || ""; return getNum(nameA) - getNum(nameB); });
        setZeroWasteList(sorted);
      } 
      else{
        enqueueSnackbar("Lỗi hệ thống", { variant: "error" });
      }
    })();
  },[payload, reload]);
  
  const handleReload = () => {
    setReload(reload => !reload)
  }

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | null>(null);

  const handleOpenDeleteConfirm = (id: string) => {
    setIdToDelete(id);
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
    setIdToDelete(null);
  };

  const handleDeleteFeeItem = async () => {
    if (!idToDelete) return;
    try {
      const res = await donationApi.deleteZeroWaste({ id: idToDelete });
      if (res.data.code === 0) {
        handleReload();
        enqueueSnackbar("Đã xóa khung trọng lượng!", { variant: "success" });
      } else {
        enqueueSnackbar("Lỗi xóa: " + (res.data.debugMessage || res.data.message), { variant: "error" });
      }
      handleCloseDeleteConfirm();
    } catch (error) {
      enqueueSnackbar("Xóa thất bại", { variant: "error" });
      handleCloseDeleteConfirm();
    }
  };

  const currentPartnerId = zeroWasteList && zeroWasteList.length > 0 ? zeroWasteList[0].partnerId : '';

  return (
    <div className={clsx(styles.root, className && className)}>
      <h2>Cấu hình phí xử lí không phát thải</h2>
      <ZeroWasteFeeConfigModal currentPartnerId={currentPartnerId} onSuccess={handleReload} />
      <div className={styles.zeroWaste}>
        <ZeroWasteList handleReload={handleReload} zeroWasteList={zeroWasteList} onDelete={handleOpenDeleteConfirm} />
      </div>

      <Dialog
        open={openDeleteConfirm}
        onClose={handleCloseDeleteConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận xóa"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn xóa khung trọng lượng này không?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm}>Hủy</Button>
          <Button onClick={handleDeleteFeeItem} autoFocus color="error">
            Xóa
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ZeroWasteFee;


